import React from "react";
import { selectLogo } from "./selectLogo";
import styles from "./styles/file.module.css";

function FileIcon({
  filename,
  date,
  size,
  deleteable = true,
  OnClick,
  OnDelete,
}) {
  const filetype = filename.split(".")[filename.split(".").length - 1];
  function timestamp2Date(timestamp) {
    var date = new Date(timestamp);
    var year = date.getFullYear();
    var month = (1 + date.getMonth()).toString().padStart(2, "0");
    var day = date.getDate().toString().padStart(2, "0");
    return year + "/" + month + "/" + day;
  }
  function formatFileSize(bytes) {
    if (bytes < 1024) {
      return bytes + " bytes";
    } else if (bytes < 1048576) {
      return (bytes / 1024).toFixed(1) + " KB";
    } else if (bytes < 1073741824) {
      return (bytes / 1048576).toFixed(1) + " MB";
    } else {
      return (bytes / 1073741824).toFixed(1) + " GB";
    }
  }

  const formatFileName = (fileName) => {
    if (fileName.length > 0) {
      const maxLength = 30; // Maximum length of the displayed file name

      // Split the file name into its name and extension parts
      const parts = fileName.split(".");
      const namePart = parts.slice(0, -1).join("."); // Join all parts except the last one (extension)
      const extension = parts[parts.length - 1]; // Get the extension

      // Format the name part by truncating and adding '...' if it's longer than maxLength
      let formattedName =
        namePart.length <= maxLength
          ? namePart
          : namePart.slice(0, maxLength - 3) + "...";

      // Combine the formatted name and extension
      formattedName += "." + extension;

      // Display the formatted file name
      return formattedName;
    } else {
      return ""; // Clear the display if no file is selected
    }
  };
  return (
    <div onClick={OnClick} className={styles.main} title={filename}>
      {deleteable ? (
        <div
          onClick={(e) => {
            e.stopPropagation();
            OnDelete();
          }}
          className={styles.delete}
        ></div>
      ) : null}
      <div className={styles.flex_container}>
        <div
          className={styles.file_icon}
          style={{ backgroundImage: `url(${selectLogo(filetype)})` }}
        />
      </div>
      <div className={styles.filename}>{formatFileName(filename)}</div>
      <div className={styles.file_info}>
        <span className={styles.info}>{timestamp2Date(Number(date))}</span>
        <div className={styles.point}></div>
        <span className={styles.info}>{formatFileSize(size)}</span>
      </div>
    </div>
  );
}

export default FileIcon;
